module.exports = __webpack_public_path__ + "img/circles-4.656ba50b.svg";